import { BaseCollection } from './base-collection.model';
import { Supplier } from './supplier.model';
import { TestResult } from './test-result.model';

export enum ScheduledTaskState {
  SCHEDULED = 'SCHEDULED',
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
  FINISHED = 'FINISHED',
  PAUSED = 'PAUSED',
}

export interface ScheduledTask {
  id?: number;
  createdAt?: string;
  startAt?: string | number;
  finishAt?: string | number;
  title?: string;
  description?: string;
  zoneOffsetSec?: number;
  sendOnlyOnce?: boolean;
  state?: ScheduledTaskState;
  repeatEvery?: number;
  reportEmails?: string[];
  daysOfWeek?: string[];
  reportRuleDtos?: ScheduledTaskReportRule[];
  reportRules?: ScheduledTaskReportRule[];
  reportFrequency?: string;
  userId?: number;
  testCaseTemplateId?: number;
  fromHour?: string | number;
  tillHour?: string | number;
  reportPerAlertEnabled?: boolean;
  repetitionReportPerAlertEnabled?: boolean;
  allAlertXlsReportEnabled?: boolean;
  repetitionAlertXlsReportEnabled?: boolean;
  allTestXlsReportEnabled?: boolean;
  runUntilDisabled?: boolean;
  randomized?: boolean;
  testRepeatsPerIteration: number;
  repeatsPerDayRandomized?: number;
  callbackUrl: string;
  coverageNotificationEnabled: boolean;
}

export interface ScheduledTaskReportRule {
  testStatus: string;
  testStatusWaitingTime: number;
  messageState: string;
  messageStateWaitingTime: number;
  isConsecutive?: boolean;
  repetitionsTarget?: number;
}

export interface Report {
  id: number;
  createdAt: string;
  createdAtFormat: string[];
  emails: string[];
  scheduledTaskTitle: string;
  scheduledTaskId?: number;
  reportRuleDto: ScheduledTaskReportRule;
  supplierDto: Supplier;
  testDto: TestResult;
  comment: string;
}

export interface UpdateReportDto {
  comment: string;
}

export interface ReportsCollection extends BaseCollection {
  content: Report[];
}

export interface ScheduledTasksCollection extends BaseCollection {
  content: ScheduledTask[];
}

export interface TaskBulkActionDto {
  taskIds: number[];
}

export type SchedulerBulkActionType = 'stop' | 'pause' | 'resume';

export interface SchedulerBulkActionTaskModalInfo {
  actionType: SchedulerBulkActionType;
  taskIds: number[];
}
